import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, AiModel, Maybe } from "types/generated";

export type AiIntegrationModelView = Pick<AiModel, "id" | "name">;

export type AiIntegrationView = Pick<
  AiIntegration,
  | "id"
  | "name"
  | "description"
  | "labels"
  | "provider"
  | "isSpaceliftProvided"
  | "providerConfig"
  | "baseURL"
  | "models"
  | "providerIntegrationId"
  | "providerIntegrationName"
  | "tokenUsage"
  | "enabled"
  | "allowedActions"
> & {
  modelDetails: AiIntegrationModelView[];
  space: Maybe<Pick<NonNullable<AiIntegration["space"]>, "id" | "name">>;
};

type SearchAiIntegrationsData = {
  aiIntegrations: AiIntegrationView[];
};

export const SEARCH_AI_INTEGRATIONS: TypedDocumentNode<SearchAiIntegrationsData> = gql`
  query SearchAiIntegrations {
    aiIntegrations {
      id
      name
      description
      labels
      provider
      enabled
      allowedActions
      modelDetails {
        id
        name
      }
      isSpaceliftProvided
      providerConfig {
        ... on AWSBedrockConfig {
          region
          profiles
        }
      }
      baseURL
      models
      providerIntegrationId
      providerIntegrationName
      space {
        id
        name
        accessLevel
      }
      tokenUsage {
        tokensResetAt
        totalTokens
        usedTokens
      }
    }
  }
`;
